export const PANDUAN_PEJABAT_PENILAI_KINERJA_URL =
  'https://pusatinformasi.ult.kemendikdasmen.go.id/hc/id-id/articles/40469192473753-Tentang-Pemutakhiran-Data-Pegawai-Untuk-Pengelolaan-Kinerja-Pengawas-Sekolah-PKPS'

export const PANDUAN_TAHAPAN_PERENCANAAN_KINERJA_URL =
  'https://pusatinformasi.ult.kemendikdasmen.go.id/hc/id-id/articles/40469470244505-Tahapan-Perencanaan-Kinerja-Pengawas-Sekolah'

export const PANDUAN_TANPA_SEKOLAH_BINAAN_URL =
  'https://pusatinformasi.ult.kemendikdasmen.go.id/hc/id-id/articles/44453512800153-Mengatasi-Kendala-Perencanaan-Kinerja-Pengawas-Sekolah-Tanpa-Sekolah-Binaan'

export const PANDUAN_SURVEI_PENDAMPINGAN_SEKOLAH_URL =
  'https://pusatinformasi.ult.kemendikdasmen.go.id/hc/id-id/articles/43595386165017-Cara-Mengisi-Survei-Pendampingan-Pengawas-Sekolah-Oleh-Kepala-Sekolah'

export const PANDUAN_ROTASI_MUTASI_URL =
  'https://pengaduan.ult.kemendikdasmen.go.id/hc/id-id/requests/new'

export const PANDUAN_PENETAPAN_PREDIKAT_KINERJA_PPK_URL =
  'https://pusatinformasi.ult.kemendikdasmen.go.id/hc/id/articles/51513405389849-Cara-Mengubah-dan-Mengirimkan-Penetapan-Predikat-Kinerja-Tahunan-Pengawas-Sekolah-Oleh-Kepala-DInas-Pendidikan'

export const PANDUAN_HASIL_PENETAPAN_PREDIKAT_URL =
  'https://pusatinformasi.ult.kemendikdasmen.go.id/hc/id/articles/51513357740057-Tentang-Dokumen-Hasil-Penilaian-Kinerja-Pengawas-Sekolah'
